import { useEffect, useRef, useState } from "react";
import { ChevronDown, X } from "lucide-react";
import { getPurchaseOrderStatusConfig } from "./config";
import {
  StatusBoxWrapper,
  StatusBoxTrigger,
  StatusChipSummary,
  StatusSummaryChip,
  StatusSummaryMore,
  StatusDropdown,
  StatusOption,
} from "./styles.purchaseOrderListDesktop";

export default function StatusMultiSelectBox({ statuses, selected, onToggle }) {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const firstSelectedConfig = selected.length > 0 ? getPurchaseOrderStatusConfig(selected[0]) : null;

  return (
    <StatusBoxWrapper ref={wrapperRef}>
      <StatusBoxTrigger type="button" onClick={() => setIsOpen((open) => !open)}>
        {selected.length > 0 ? (
          <StatusChipSummary>
            <StatusSummaryChip>
              {firstSelectedConfig.label}
              <X
                size={12}
                onClick={(event) => {
                  event.stopPropagation();
                  onToggle(selected[0]);
                }}
              />
            </StatusSummaryChip>
            {selected.length > 1 && <StatusSummaryMore>& {selected.length - 1} more</StatusSummaryMore>}
          </StatusChipSummary>
        ) : (
          <span>Select status</span>
        )}
        <ChevronDown size={16} />
      </StatusBoxTrigger>
      {isOpen && (
        <StatusDropdown>
          {statuses.map((status) => {
            const statusConfig = getPurchaseOrderStatusConfig(status);
            return (
              <StatusOption key={status}>
                <input
                  type="checkbox"
                  checked={selected.includes(status)}
                  onChange={() => onToggle(status)}
                />
                {statusConfig.label}
              </StatusOption>
            );
          })}
        </StatusDropdown>
      )}
    </StatusBoxWrapper>
  );
}
